export default __webpack_public_path__ + "media/color/ary-10e3f625.svg";